/**
 * Module dependencies.
 */

import Script from 'next/script';

/**
 * `Props` type.
 */

type Props = {
  partnerId: string
};

/**
 * Export `LinkedInInsightTag` component.
 */

export default function LinkedInInsightTag({ partnerId }: Props) {
  return (
    <>
      <Script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line id-match
          __html: `
          _linkedin_partner_id = "${partnerId}";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
          `
        }}
        id={'linkedin-insight-tag-setup'}
        strategy={'afterInteractive'}
      />
      
      <Script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line id-match
          __html: `
          (function(l) {
            if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
            window.lintrk.q=[]}
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
            })(window.lintrk);
          `
        }}
        id={'linkedin-insight-tag-script'}
        strategy={'afterInteractive'}
      />
      
      <noscript>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line id-match
            __html: `<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif" />`
          }}
        />
      </noscript>
    </>
  );
} 